var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4531 12.8948C15.3016 13.5215 14.5857 13.9644 13.1539 14.8502C11.7697 15.7064 11.0777 16.1346 10.5199 15.9625C10.2893 15.8913 10.0792 15.7562 9.90982 15.57C9.5 15.1198 9.5 14.2465 9.5 12.5C9.5 10.7535 9.5 9.88018 9.90982 9.42995C10.0792 9.24381 10.2893 9.10868 10.5199 9.03753C11.0777 8.86544 11.7697 9.29357 13.1539 10.1498C14.5857 11.0356 15.3016 11.4785 15.4531 12.1052C15.5156 12.3639 15.5156 12.6361 15.4531 12.8948Z",
    stroke: "#F7F7F7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.8125C3 6.89395 3 4.93467 4.2985 3.71734C5.59698 2.5 7.68688 2.5 11.8667 2.5H13.1333C17.3131 2.5 19.403 2.5 20.7015 3.71734C22 4.93467 22 6.89395 22 10.8125V13.1875C22 17.106 22 19.0653 20.7015 20.2827C19.403 21.5 17.3131 21.5 13.1333 21.5H11.8667C7.68688 21.5 5.59698 21.5 4.2985 20.2827C3 19.0653 3 17.106 3 13.1875V10.8125Z",
    stroke: "#F7F7F7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.614ae34e3f2d54200f816f39e9bfe501.svg";
export { ForwardRef as ReactComponent };